import React, { useState } from "react";

const GATE_KEY = "tv_dev_gate";
const GATE_PASSWORD = process.env.REACT_APP_PUBLIC_GATE_PASSWORD || "totalview2026";

/**
 * Simple password gate for dev environments.
 * Active only when REACT_APP_PUBLIC_GATE=true.
 * Stores unlock in sessionStorage (clears when tab closes).
 */
const DevGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isGateEnabled = process.env.REACT_APP_PUBLIC_GATE === "true";
  const [unlocked, setUnlocked] = useState(
    () => !isGateEnabled || sessionStorage.getItem(GATE_KEY) === "1"
  );
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  if (unlocked) return <>{children}</>;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === GATE_PASSWORD) {
      sessionStorage.setItem(GATE_KEY, "1");
      setUnlocked(true);
    } else {
      setError(true);
      setInput("");
    }
  };

  return (
    <div className="min-h-screen bg-surface-900 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-surface-800 rounded-2xl border border-border p-8 shadow-xl text-center">
          <img src="/quantum-small.png" alt="TotalView" className="h-10 w-10 mx-auto mb-4" />
          <h1 className="text-h4 font-bold text-text-primary mb-1">Preview Access</h1>
          <p className="text-body-sm text-text-secondary mb-6">
            This is a development preview. Enter the password to continue.
          </p>
          <form onSubmit={handleSubmit} className="space-y-3">
            <input
              type="password"
              value={input}
              onChange={(e) => { setInput(e.target.value); setError(false); }}
              placeholder="Password"
              autoFocus
              className="input w-full text-center"
            />
            {error && (
              <p className="text-body-sm text-health-400">Incorrect password</p>
            )}
            <button type="submit" className="btn-primary w-full py-2.5 text-body-sm">
              Enter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DevGate;
